import { render, staticRenderFns } from "./crossevent.vue?vue&type=template&id=9e8bf814&scoped=true"
import script from "./crossevent.vue?vue&type=script&lang=js"
export * from "./crossevent.vue?vue&type=script&lang=js"
import style0 from "./crossevent.vue?vue&type=style&index=0&id=9e8bf814&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e8bf814",
  null
  
)

export default component.exports